import { produce } from 'immer';
import { DateTime } from 'luxon';
import { extractError } from 'app/lib/error';
import {
    CREATE_ASSET_PROPERTY_DEFINITION_SUCCESS_ASSET_PROPERTY_DEFINITION_CREATED,
    UPDATE_ASSET_PROPERTY_DEFINITION_SUCCESS_ASSET_PROPERTY_DEFINITION_UPDATED,
    DELETE_ASSET_PROPERTY_DEFINITION_SUCCESS_ASSET_PROPERTY_DEFINITION_DELETED
} from 'app/store/__generated__/events';
import {
    CREATE_ATTRIBUTE_DEFINITION,
    UPDATE_ATTRIBUTE_DEFINITION,
    DELETE_ATTRIBUTE_DEFINITION,
    LOAD_ATTRIBUTE_DEFINITIONS,
    SET_ATTRIBUTE_VALUE,
    DELETE_ATTRIBUTE_VALUE,
    OPEN_DIALOG,
    CLOSE_DIALOG
} from './types.js';

export const INITIAL_STATE = {
    definitionsByAttributeId: {},
    showDialog: false,
    error: null
};

function ensureAttributeExists(draft, id) {
    if (!draft.definitionsByAttributeId.hasOwnProperty(id)) {
        draft.definitionsByAttributeId[id] = {};
    }
}

function storeAttribute(draft, attribute) {
    const { uid } = attribute;
    ensureAttributeExists(draft, uid);
    Object.assign(draft.definitionsByAttributeId[uid], attribute);
}

export const attributesReducer = produce((draft, action) => {
    switch (action.type) {
        case OPEN_DIALOG:
            draft.showDialog = true;
            draft.error = null;
            break;
        case CLOSE_DIALOG:
            draft.showDialog = false;
            break;
        case LOAD_ATTRIBUTE_DEFINITIONS.SUCCEEDED:
            for (const attribute of action.payload.assetPropertyDefinitionDtos) {
                storeAttribute(draft, attribute);
            }
            break;
        case CREATE_ATTRIBUTE_DEFINITION.STARTED:
        case UPDATE_ATTRIBUTE_DEFINITION.STARTED:
        case DELETE_ATTRIBUTE_DEFINITION.STARTED:
        case SET_ATTRIBUTE_VALUE.STARTED:
        case DELETE_ATTRIBUTE_VALUE.STARTED:
            draft.error = null;
            break;
        case CREATE_ASSET_PROPERTY_DEFINITION_SUCCESS_ASSET_PROPERTY_DEFINITION_CREATED:
            storeAttribute(draft, { ...action.payload, createdAt: DateTime.utc().toISO() });
            draft.showDialog = false;
            break;
        case UPDATE_ASSET_PROPERTY_DEFINITION_SUCCESS_ASSET_PROPERTY_DEFINITION_UPDATED: {
            const { uid, name, payload } = action.payload;
            draft.definitionsByAttributeId[uid].name = name;
            draft.definitionsByAttributeId[uid].payload.defaultValue = payload.defaultValue;

            if (payload.options) {
                draft.definitionsByAttributeId[uid].payload.options = payload.options;
            }

            draft.showDialog = false;
            break;
        }
        case CREATE_ATTRIBUTE_DEFINITION.FAILED:
        case UPDATE_ATTRIBUTE_DEFINITION.FAILED:
            draft.error = extractError(action.payload);
            break;
        case DELETE_ASSET_PROPERTY_DEFINITION_SUCCESS_ASSET_PROPERTY_DEFINITION_DELETED: {
            const id = action.payload.uid;

            delete draft.definitionsByAttributeId[id];

            break;
        }
        default:
    }
}, INITIAL_STATE);
